<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    page: {
        title: "Active Contracts",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Payment History",
            items: [
                {
                text: "Payment History",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            responseDt:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            programList:[],
            date: '',
            key_search:'',
            dtKey:0,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY, H:mm:ss')
            }
        },

        downloadExcel: function () {
            //location.href= process.env.VUE_APP_API_BASEURL+'contract/export';
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                program_id: this.program_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'contract/export', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    console.log(response);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Contracts List.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getPaymentHistoryListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'payment_history/getlisting')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.responseDt = response.data;
                    console.log(this.responseDt);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        submitForm(e)
        {
            this.ButtonSeen=true;
            e.preventDefault()
            
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'payment_history/search', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.responseDt = response.data;
                    this.dtKey +=1;
                    console.log(this.responseDt);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        resetForm: function () { 
            this.date = ''; 
            this.key_search = '';
            this.getPaymentHistoryListing();
        },

        //raw data----------------------------------------------------------
        get_program(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    this.programList = response.data;
                    console.log(this.programList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        //raw data----------------------------------------------------------

    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
    },

    mounted() {
        this.getPaymentHistoryListing();
        this.get_program();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <div class="card">
            <div class="card-header border-bottom-dashed">
                <!--div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Payment History List</h5>
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <div>
                            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div>
                    </div>
                </div-->
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit="submitForm">
                    <div class="row g-3">
                        <div class="col-xl-7">
                            <div class="search-box">
                                <input type="text" class="form-control search"
                                placeholder="Search for Customer Name, NRIC, Reference Number" v-model="key_search"/>
                                <i class="ri-search-line search-icon"></i>
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col-xl-5">
                            <div class="row g-3">
                                <div class="col-sm-12">
                                    <div class="">
                                        <flat-pickr v-model="date" placeholder="Select Date" :config="rangeDateconfig"
                                        class="form-control"></flat-pickr>
                                    </div>
                                </div>                           
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row g-3 justify-content-end">
                        <div class="col-xl-2">
                            <div>
                                <button type="submit" class="btn btn-primary w-100">
                                    <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-2">
                            <div>
                                <button @click='resetForm' class="btn btn-danger w-100">
                                    <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example">  
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>                                                      
                                            <th scope="col">Reference Number</th>           
                                            <th scope="col">Customer Name</th>           
                                            <th scope="col">Order Number</th>           
                                            <th scope="col">Tenure</th>           
                                            <th scope="col">NRIC</th>           
                                            <th scope="col">Price</th>           
                                            <th scope="col">Contract Date</th>                                                      
                                            <th scope="col">Contract Number</th>
                                            <th scope="col">Payment Date</th>
                                            <th scope="col">Amount Paid</th>
                                            <th scope="col">Payment Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in responseDt" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ item.reference_number }}</td>                               
                                            <td>{{ item.name_as_per_nric }}</td>                               
                                            <td>{{ item.orderId }}</td>
                                            <td>{{ item.tenure }}</td>
                                            <td>{{ item.nric }}</td>
                                            <td>{{ item.price }}</td>
                                            <td>{{ item.contract_date }}</td>
                                            <td>{{ item.contract_number }}</td>
                                            <td>{{ this.format_date(item.collection_date) }}</td>                                                                                   
                                            <td>RM {{ item.collection_amount }}</td>                                                                                  
                                            <td>{{ item.collection_status }}</td>                                             
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>